 import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import {SpesenItem} from '../../spesen.model';
import {BestaetigungsFormComponent} from '../../../../ui-components/bestaetigungs-form/bestaetigungs-form.component';
import {deleteZeitStart} from '../../store/actions/Zeit-del.actions';
import {MatDialog} from '@angular/material/dialog';
import {select, Store} from '@ngrx/store';
import {Zeitstate} from '../../store/reducer/zeiterfassung.reducer';
import {deleteSpeseStart} from '../../store/actions/spese-del.actions';
import {SpesenFormdialogComponent} from '../spesen-form-dialog/spesen-formdialog.component';
 import {BreakpointObserver} from '@angular/cdk/layout';
 import {map} from 'rxjs/operators';

@Component({
    selector: 'app-spesen-table',
    templateUrl: './spesen-table.component.html',
    styleUrls: ['./spesen-table.component.scss'],
})
export class SpesenTableComponent implements OnInit {
  public displayedColumns: string[];

  public dataSource = new MatTableDataSource<SpesenItem>();

  constructor(
    public dialog: MatDialog,
    public store: Store<{ zeiterfassung: Zeitstate }>,
    private breakpointObserver: BreakpointObserver
  )
  {
  }

  @Input()
  public showFunctionMenu = true;

  @Input()
  public zeitId: number;

  /**
   * Sets addresses to datasource
   *
   * @param addresses - The addresses
   */
  @Input()
  public set spesen(spesen: SpesenItem[]) {
    this.dataSource.data = spesen;
  }
  public isSmallDevice = false;

    /**
     * Executed in initialization
     */
    public ngOnInit(): void {
      this.breakpointObserver
        .observe(localStorage.getItem('phoneWidth'))
        .pipe(map((result) => result.matches))
        .subscribe((isSmallDevice) => {
          this.isSmallDevice = isSmallDevice;
          if(this.isSmallDevice){
            this.displayedColumns = [
              'bezeichnung',
              'menge',
              'betragInt',
              'actions',
            ];
          }
          else{
            this.displayedColumns = [
              'bezeichnung',
              'menge',
              'betragInt',
              'betragExt',
              'beschreibung',
              'actions',
            ];
          }

        });
    }

  public zeiterfassung(): void {
    console.log('Verlinkung zu Zeiterfassung');
  }

  public editSpese(spese: SpesenItem): void {
    this.dialog.open(SpesenFormdialogComponent, {
      data: {
        title: 'pages.zeitverwaltung.addSpesenDialog.title',
        submitButtonLabel: 'pages.addTimeDialog.submitButtonLabel',
        cancelButtonLabel: 'pages.addTimeDialog.cancelButtonLabel',
        zeitId: this.zeitId,
        id: spese.id,
        menge: parseFloat(String(spese.menge)),
        beschreibung: spese.beschreibung,
        spesenArt: spese.rspeId,
        betragInt: parseFloat(String(spese.betragInt)),
        betragExt: parseFloat(String(spese.betragExt)),
      },
    });
  }

  public deleteSpese(spese: SpesenItem): void {

    const bestätigungsForm = this.dialog.open(BestaetigungsFormComponent, {
      data: {
        title: 'pages.zeitverwaltung.deleteSpese.title',
        text: 'pages.zeitverwaltung.deleteSpese.text'
      },
    });
    bestätigungsForm.afterClosed().subscribe(result => {
      if (result === true){
        this.store.dispatch(deleteSpeseStart({item: spese}));
      }
    });

  }

}
